import Pikaday from 'pikaday';
import 'pikaday/plugins/pikaday.jquery';

window.Pikaday = Pikaday;
